// Google/Microsoft sign-in buttons (backlog AUTH-8), design from Lovable
// (2026-09-04). Provider buttons stay neutral (white, official multi-color
// marks) rather than the app's amber gradient/ghost styles — the marks are
// how users recognize the provider, not something to reskin.
import { useT } from "@/lib/i18n";

function GoogleMark() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden className="h-5 w-5 shrink-0">
      <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" />
      <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" />
      <path fill="#FBBC05" d="M11.69 28.18A13.2 13.2 0 0 1 11 24c0-1.45.25-2.86.69-4.18v-5.7H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" />
      <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z" />
    </svg>
  );
}

function MicrosoftMark() {
  return (
    <svg viewBox="0 0 23 23" aria-hidden className="h-5 w-5 shrink-0">
      <rect x="1" y="1" width="10" height="10" fill="#F25022" />
      <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
      <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
      <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
    </svg>
  );
}

const providerButtonClass =
  "flex h-14 w-full items-center justify-center gap-3 rounded-xl border border-border bg-white font-display text-xl uppercase tracking-wide text-[#1f1f1f] transition-opacity hover:opacity-90 disabled:opacity-60";

export function SsoButtons({
  onGoogle,
  onMicrosoft,
  disabled,
}: {
  onGoogle: () => void;
  onMicrosoft: () => void;
  disabled?: boolean;
}) {
  const t = useT();

  return (
    <div className="mt-6 space-y-3">
      <button type="button" className={providerButtonClass} onClick={onGoogle} disabled={disabled}>
        <GoogleMark />
        {t("sso.google")}
      </button>
      <button type="button" className={providerButtonClass} onClick={onMicrosoft} disabled={disabled}>
        <MicrosoftMark />
        {t("sso.microsoft")}
      </button>
    </div>
  );
}

export function AuthDivider() {
  const t = useT();

  return (
    <div className="mt-6 flex items-center gap-4">
      <span className="h-px flex-1 bg-border" />
      <span className="sd-label text-[10px]">{t("sso.divider")}</span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
